
import { Component, Vue, Prop as prop, Watch as watch } from 'nuxt-property-decorator';
import { mapState } from 'vuex';
import { showErrorFlash, showFlash } from '~/lib/flash';
import { validateWithScroll } from '~/lib/scrollValidator';

@Component({
    components: {
        formField: require('~/components/form/form-field/').default,
        VueRecaptcha: require('vue-recaptcha').default,
        btn: require('~/components/form/button').default,
    },
    computed: mapState(['user']),
})
export default class QuestionFieldComponent extends Vue {

    @prop()
    public productId: number;

    public showField = false;
    public user: User;
    loading = false;
    message = '';

    name = '';
    email = '';

    private siteKey = '6LcNYskUAAAAAKJCkqqwtLbg6TIV-xBU7QEtI2oo';

    showForm(event: FocusEvent) {
        // if (!this.user) {
        //     this.$store.commit('setLoginFormState', true);
        //     (event.target as HTMLInputElement).blur();
        //     return;
        // }

        this.showField = true;
    }

    close() {
        this.showField = false;
        this.message = '';
    }

    startSend() {

        if (this.loading || !this.valid) {
            return;
        }

        this.loading = true;
        (this.$refs.invisibleRecaptcha as any).execute();
    }

    async sendReview(response: string) {

        try {
            await this.$store.dispatch('RestFormRequest', {
                url: '/catalog/reviews/question/add',
                params: {
                    token: response,
                    name: this.name,
                    email: this.email,
                    offer_id: this.productId,
                    message: this.message,
                }
            });

            showFlash({
                text: 'Ваш вопрос отправлен',
                type: 'success',
                timeout: 3000,
            });

            this.showField = false;
        } catch (err) {
            console.error(err);
            showErrorFlash("Ошибка при отправке отзыва");
        } finally {
            this.loading = false;
        }
    }

    @watch('user')
    onUserLogout() {
        if (!this.user) {
            this.showField = false;
        }
    }

    get valid(): boolean {

        if (this.user) {
            return true;
        }

        return validateWithScroll(this, ['nameField', 'emailField']);
    }
}
